import { supabase } from "@/lib/supabase";

const SESSION_KEY = "analytics_session_id";

function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export async function trackEvent(
  eventName: string,
  metadata: Record<string, any> = {}
) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from("analytics_events").insert({
      event_name: eventName,
      path: window.location.pathname,
      referrer: document.referrer || null,
      session_id: getSessionId(),
      user_id: user?.id ?? null,
      metadata,
    });
  } catch (e) {
    // Fail silently — analytics must never break the app
    console.debug("analytics:", e);
  }
}

export function trackPageView() {
  return trackEvent("page_view");
}
